import { SHOP_PRODUCTS_PATH_A } from '@constant'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import auth, { UNPAID } from '../../auth'
import styles from './style.module.less'

/** 未付费商家 */
@auth(UNPAID)
@observer
export default class extends Component {
  render() {
    const title = '商家服务（付费）'
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>暂未开通{title}</div>
        <div className={styles.detail}>
          <span className={styles.text}>
            开通{title}，独享营销神器，客资转化+经营效率，全面飞跃
          </span>
        </div>
        <a className={styles.btn} href={SHOP_PRODUCTS_PATH_A}>
          立即开通
        </a>
      </div>
    )
  }
}
